<template>
  <div v-click-outside="doUnroll">
      <div @click="doRoll()">
          <span>{{ _tr("global.subscribe", "Je souscris") }}&nbsp;</span>
          <fa :icon="getCaret(unroll)" :key="unroll"/>
      </div>
      <nav v-show="unroll" @click="registerChargebee()">
        <div class="menu-options">
          <a 
            class="subscription-option" 
            href="javascript:void(0)" 
            data-cb-type="checkout" 
            data-cb-item-0="executive-plan-EUR-Monthly" 
            data-cb-item-0-quantity = "1" > 
              {{ _tr("global.monthly", "Mensuel") }} 
          </a>
          <a 
            class="subscription-option" 
            href="javascript:void(0)" 
            data-cb-type="checkout" 
            data-cb-item-0="executive-plan-EUR-Yearly" 
            data-cb-item-0-quantity = "1" > 
              {{ _tr("global.annual", "Annuel") }} 
          </a>
        </div>
      </nav>
  </div>
</template>

<script>
import user from "@/components/user/user.js";

export default {
  mixins: [user],
  methods: {
    registerChargebee() {
      Chargebee.registerAgain();
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";

.menu-options {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  background-color: white;
  border-radius: 5px;
  line-height: 40px;
  z-index: 5;
  box-shadow: 10px 6px 20px -5px rgba(0, 0, 0, 0.1);
}

.subscription-option {
  border-radius: 5px;
  text-decoration: none;
  background-color: white;
  color: $text-grey;
}

.subscription-option:hover {
  background-color: $primary;
  color: white;
}
</style>
